import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from '../../globals';
import { Alarm } from './alarms.interfaces';

@Injectable({
  providedIn: 'root',
})
/**
 * Alarms REST calls
 */
export class AlarmsService {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);


  /**
   * Get all alarms
   */
  getAlarms(): Observable<Alarm[]> {
    const url = `${this.globals.apiRoot}/alarms`;
    return this.http.get<Alarm[]>(url);
  }

  getAlarmsByInstallationId(
    installationId: number,
    isShared: boolean,
  ): Observable<Alarm[]> {
    const url = `${this.globals.apiRoot}/alarms/installation/${installationId}?isShared=${isShared}`;
    return this.http.get<Alarm[]>(url);
  }

  /**
   * Get alarm by id
   */
  getAlarm(id: number): Observable<Alarm> {
    const url = `${this.globals.apiRoot}/alarm/v2/${id}`;
    return this.http.get<Alarm>(url);
  }

  /**
   * Update an alarm
   * @param alarm the alarm to update
   */
  updateAlarm(alarm: Alarm): Observable<void> {
    const url = `${this.globals.apiRoot}/alarms/v2/${alarm.ID}`;
    return this.http.put<void>(url, alarm);
  }

  /**
   * Update an alarm, set active or not
   * @param alarm the alarm to update
   */
  updateActive(alarm: Alarm): Observable<void> {
    const url = `${this.globals.apiRoot}/alarms/v2/active`;
    return this.http.put<void>(url, alarm);
  }

  /**
   * Add a new alarm
   */
  addAlarm(alarm: Alarm): Observable<void> {
    const url = `${this.globals.apiRoot}/alarms/add`;
    return this.http.post<void>(url, alarm);
  }

  /**
   * Delete an alarm
   */
  deleteAlarm(id: number): Observable<void> {
    const url = `${this.globals.apiRoot}/alarms/delete/${id}`;
    return this.http.delete<void>(url);
  }
}
